import React from 'react';

const ChatWindow = ({ currentChat, newMessage, setNewMessage, handleSendMessage }) => {
  return (
    <div className="chat-window">
      <div className="chat-header">
        <div className="chat-header-info">
          <img src={currentChat.profilePic} alt="profile" className="profile-pic-large" />
          <div className="chat-header-details">
            <div className="name">{currentChat.name}</div>
            <div className="status">{currentChat.status}</div>
          </div>
        </div>
        <div className="chat-header-actions">
          <button className="call-btn">📞</button>
          <button className="video-call-btn">🎥</button>
        </div>
      </div>

      <div className="chat-messages">
        {currentChat.messages.map((message, index) => (
          <div 
            key={index} 
            className={`chat-message ${message.type === 'sent' ? 'sent' : 'received'}`}
          >
            <div className="message-header">
              <span className="sender">{message.sender}</span>
            </div>
            <div className="message-text">
              {message.text}
            </div>
          </div>
        ))}
      </div>

      <div className="chat-footer">
        <button className="emoji-btn">😊</button>
        <button className="attach-btn">📎</button>
        <input 
          type="text" 
          placeholder="Type a message..." 
          value={newMessage} 
          onChange={(e) => setNewMessage(e.target.value)} 
        />
        <button onClick={handleSendMessage}>Send</button>
      </div>
    </div>
  );
};

export default ChatWindow;
